import React from 'react';
import { getCastOnDisplayName } from '../../../shared/utils/constants';

const ComponentCreatedCelebration = ({ component, onAddSteps, onAddAnother, onClose }) => {
  const getConstructionDisplay = (construction) => {
    return construction === 'flat' ? 'Flat' : 'In the Round';
  };

  const getMethodDisplay = (component) => {
    const { startType, startMethod, startDescription, startInstructions } = component;

    // Cast On methods
    if (startType === 'cast_on') {
      if (startMethod === 'other' && startDescription) {
        return startDescription; // Custom cast on description
      }
      return getCastOnDisplayName(startMethod) || 'Cast On';
    }

    // Pick Up methods
    if (startType === 'pick_up') {
      const location = startDescription || 'edge';
      if (startInstructions && startInstructions.trim()) {
        return `Pick up and knit from ${location} (${startInstructions})`;
      }
      return `Pick up and knit from ${location}`;
    }

    // Continue methods  
    if (startType === 'continue') {
      return `Continue from ${startDescription || 'stitches'}`;
    }

    // Other/Custom methods
    if (startType === 'other') {
      return startDescription || 'Custom setup';
    }

    return startMethod || 'Unknown method';
  };

  return (
    <div className="min-h-screen bg-yarn-50">
      <div className="app-container bg-yarn-50 min-h-screen shadow-lg">

        {/* Header */}
        <div className="bg-sage-500 text-white px-6 py-4">
          <div className="flex items-center gap-3">
            <button
              onClick={onClose}
              className="text-white text-xl hover:bg-white hover:bg-opacity-20 rounded-full w-10 h-10 flex items-center justify-center transition-colors"
            >
              ←
            </button>
            <div className="flex-1 text-center">
              <h1 className="text-lg font-semibold">Component Created!</h1>
            </div>
          </div>
        </div>

        <div className="p-6 bg-yarn-50 stack-lg">

          {/* Celebration Header */}
          <div className="text-center">
            <div className="text-4xl mb-3">🎉</div>
            <h2 className="content-header-primary">{component.name} Ready!</h2>
            <p className="text-wool-500 text-sm">Component successfully created</p>
          </div>

          {/* Component Summary */}
          <div className="bg-gradient-to-r from-sage-50 to-yarn-50 border-2 border-sage-200 rounded-2xl p-5 shadow-sm">

            <div className="text-center mb-4">
              <h3 className="content-header-secondary">{component.name}</h3>
              {/* REMOVED: The tiny cast-on text that was weird */}
            </div>

            <div className="bg-white bg-opacity-50 rounded-lg p-4 stack-sm">

              {/* Construction */}
              {component.construction && (
                <div className="flex items-center justify-between">
                  <span className="text-sm text-wool-600">Construction:</span>
                  <span className="font-semibold text-sage-700">{getConstructionDisplay(component.construction)}</span>
                </div>
              )}

              <div className="flex items-center justify-between">
                <span className="text-sm text-wool-600">Starting Stitches:</span>
                <span className="font-semibold text-sage-700">{component.startingStitches}</span>
              </div>

              {component.startMethod && (
                <div className="flex items-center justify-between">
                  <span className="text-sm text-wool-600">Method:</span>
                  <span className="font-semibold text-sage-700">{getMethodDisplay(component)}</span>
                </div>
              )}

              {/* Setup Notes */}
              {component.setupNotes && component.setupNotes.trim() && (
                <div className="pt-2 border-t border-wool-200">
                  <div className="text-xs font-semibold text-wool-600 mb-1">Setup Notes:</div>
                  <p className="text-sm text-wool-600 italic">"{component.setupNotes}"</p>
                </div>
              )}
            </div>
          </div>

          {/* Actions - FIXED BUTTON HIERARCHY */}
          <div className="stack-sm">

            {/* PRIMARY: Add Steps */}
            <button
              onClick={onAddSteps}
              className="w-full btn-primary btn-lg flex items-center justify-center gap-3"
            >
              <span className="text-xl">📝</span>
              <span>Add Steps to {component.name}</span>
              {/* REMOVED: Next step bubble */}
            </button>

            {/* SECONDARY: Add Another Component */}
            <button
              onClick={onAddAnother}
              className="w-full btn-secondary btn-lg flex items-center justify-center gap-2"
            >
              <span className="text-lg">🧶</span>
              <span>Add Another Component</span>
            </button>

            {/* TERTIARY: Done for Now */}
            <button
              onClick={onClose}
              className="w-full btn-tertiary"
            >
              Done for Now
            </button>
          </div>

          <div className="text-center pt-2">
            <p className="text-xs text-wool-500">
              🧶 Ready to start building your pattern!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentCreatedCelebration;